export default [
  {
    id: "ACT",
    code: 13,
    detail: 'Aceptado',
    color: 'blue-100',
    summary: 'Aceptado',
    icon: 'mdi-check',
    countries: ['CL', 'PE']
  },
  {
    id: "EPR",
    code: 8,
    detail: 'Envío procesado',
    color: 'blue-100',
    summary: 'Aceptado',
    icon: 'mdi-check',
    countries: ['CL']
  },
  {
    id: "SOK",
    code: 2,
    detail: 'Schema validado',
    color: 'yellow-100',
    summary: 'Procesando',
    icon: 'mdi-sync',
    countries: ['CL']
  },
  {
    id: "FOK",
    code: 5,
    detail: 'Firma de envío validada',
    color: 'yellow-100',
    summary: 'Procesando',
    icon: 'mdi-sync',
    countries: ['CL']
  },
  {
    id: "PDR",
    code: 6,
    detail: 'Envío en proceso',
    color: 'yellow-100',
    summary: 'Procesando',
    icon: 'mdi-sync',
    countries: ['CL']
  },
  {
    id: "REV",
    code: 15,
    detail: 'En revisión',
    color: 'yellow-100',
    summary: 'Procesando',
    icon: 'mdi-sync',
    countries: ['CL']
  },
  {
    id: "INI",
    code: 9,
    detail: 'Procesando',
    color: 'yellow-100',
    summary: 'Procesando',
    icon: 'mdi-sync',
    countries: ['CL', 'PE']
  },
  {
    id: "IMP",
    code: 10,
    detail: 'Enviado a SII',
    color: 'yellow-100',
    summary: 'Procesando',
    icon: 'mdi-sync',
    // summary: 'Aceptado',
    // icon: 'mdi-check',
    countries: ['CL', 'PE']
  },
  {
    id: "CRT",
    code: 3,
    detail: 'Carátula OK',
    color: 'yellow-100',
    summary: 'Procesando',
    icon: 'mdi-sync',
    countries: ['CL']
  },
  {
    id: "SPR",
    code: 11,
    detail: 'Pendiente',
    color: 'grey-200',
    summary: 'Pendiente',
    icon: 'mdi-clock',
    countries: ['PE']
  },
  {
    id: "RFR",
    code: 4,
    detail: 'Rechazado por parámetros de entrada incompletos',
    color: 'red-100',
    summary: 'Rechazado',
    icon: 'mdi-close',
    countries: ['CL']
  },
  {
    id: "RCT",
    code: 7,
    detail: 'Rechazado por error en carátula',
    color: 'red-100',
    summary: 'Rechazado',
    icon: 'mdi-close',
    countries: ['CL', 'PE']
  },
  {
    id: "RCP",
    code: 12,
    detail: 'Rechazado',
    color: 'red-100',
    summary: 'Rechazado',
    icon: 'mdi-close',
    countries: ['PE']
  },
  {
    id: "RCH",
    code: 14,
    detail: 'Rechazado',
    summary: 'Rechazado',
    color: 'red-100',
    icon: 'mdi-close',
    countries: ['CL']
  },
  {
    id: "RSC",
    code: 1,
    detail: 'Rechazado por error en schema',
    color: 'red-100',
    summary: 'Rechazado',
    icon: 'mdi-close',
    countries: ['CL']
  },
  {
    id: "NUL",
    code: 16,
    detail: 'Anulado',
    color: 'grey-200',
    summary: 'Anulado',
    icon: 'mdi-file-remove',
    countries: ['CL', 'PE']
  }
]
